// import userRouteMap from "./userRouteMap";

import { Login } from "pages";
import userRouteMap from "./userRouteMap";

export default function route() {
  return [
    {
      path: userRouteMap.LOGIN.path,
      name: "User Login",
      element: <Login />,
    },
  ];
}
